'use client'

import { keyframes, styled } from 'styled-components'

import { Spinner } from '@b-stock/fe-core/bstock-react'

const fadeIn = keyframes`
  from { background: rgba(255, 255, 255, 0); }
  to { background: rgba(255, 255, 255, 0.1); }
`

const Overlay = styled.div`
  align-items: center;
  animation: ${fadeIn} 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  justify-content: center;
  width: 100%;
`

export const SpinnerOverlay = () => (
  <Overlay>
    <Spinner />
  </Overlay>
)
